import { render, staticRenderFns } from "./dr-card-label-component.vue?vue&type=template&id=030c26d8"
import script from "./dr-card-label-component.vue?vue&type=script&lang=js"
export * from "./dr-card-label-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports